var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIconThree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.499 121V105.286C35.86 88.913 16.5 80.146 16.5 55C16.5 29.865 31.4985 10.692 61.501 11C83.0995 11.231 103.499 23.573 103.499 48.719L115.5 67.573C115.5 80.146 103.499 80.146 103.499 80.146C103.499 80.146 106.502 111.573 79.497 111.573V121",
    stroke: "#F8C8CF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 66C63.4174 66 66.2153 64.8411 68.2782 62.7782C70.3411 60.7153 71.5 57.9174 71.5 55C71.5 52.0826 70.3411 49.2847 68.2782 47.2218C66.2153 45.1589 63.4174 44 60.5 44C57.5826 44 54.7847 45.1589 52.7218 47.2218C50.6589 49.2847 49.5 52.0826 49.5 55C49.5 57.9174 50.6589 60.7153 52.7218 62.7782C54.7847 64.8411 57.5826 66 60.5 66Z",
    stroke: "#F8C8CF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 71.5C64.8761 71.5 69.0729 69.7616 72.1673 66.6673C75.2616 63.5729 77 59.3761 77 55C77 50.6239 75.2616 46.4271 72.1673 43.3327C69.0729 40.2384 64.8761 38.5 60.5 38.5C56.1239 38.5 51.9271 40.2384 48.8327 43.3327C45.7384 46.4271 44 50.6239 44 55C44 59.3761 45.7384 63.5729 48.8327 66.6673C51.9271 69.7616 56.1239 71.5 60.5 71.5Z",
    stroke: "#F8C8CF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.3 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIconThree);
export default __webpack_public_path__ + "static/media/background_icon_three.bcceb05dabd66e5ac36d92bcd028cf97.svg";
export { ForwardRef as ReactComponent };